'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import { BLOCKS } from '@contentful/rich-text-types';

import CardProduct from 'components/cards/CardProduct';
import ButtonCTA from 'components/ui/ButtonCTA';
import Img from 'components/ui/Img';
import RichText from 'components/ui/RichText';
import Text from 'components/ui/Text';
import TextEyebrow from 'components/ui/TextEyebrow';

import { useTheme } from 'hooks/useTheme';
import { getColor } from 'utils';
import { blockRootProps } from 'utils';

import styles from './BlockSimpleProductList.module.scss';

const MAKERS_END_CARD_MOBILE =
    'https://images.ctfassets.net/j8tkpy1gjhi5/7bO9PEqtaH2JWQ8oIUfFmT/2b260bd8da9b6c0d69944343864d0134/find-us-near-you-mobile.png';

const MAKERS_END_CARD_DESKTOP =
    'https://images.ctfassets.net/j8tkpy1gjhi5/2vUP6rvpQLe1xD6O19CHcA/fade6a6415546251afd2e148193aa86c/find-us-near-you-desktop.png';

const richTextOverrides = {
    renderNode: {
        [BLOCKS.PARAGRAPH]: (node, children) => {
            return (
                <Text.Theme
                    as="p"
                    config={{
                        default: {
                            baseTheme: 'headingXSmall',
                        },
                        'makers-reserve': {
                            baseTheme: 'bodyMedium',
                        },
                    }}
                    className={styles.endCardText}
                >
                    {children}
                </Text.Theme>
            );
        },
    },
};

const BlockSimpleProductList = ({
    __typename,
    anchorId,
    products,
    headline,
    eyebrow,
    endCard,
    flushTop,
    flushBottom,
}) => {
    const [globalTheme] = useTheme();
    const isMakersReserve = globalTheme === 'makers-reserve';

    return (
        <div
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.root, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
                [styles['theme--makers-reserve']]:
                    globalTheme === 'makers-reserve',
            })}
        >
            <TextEyebrow
                className={styles.eyebrow}
                headline={headline}
                eyebrow={eyebrow}
                globalTheme={globalTheme}
                theme={globalTheme === 'makers-reserve' ? null : 'ultrabold'}
                eyebrowColor={
                    globalTheme === 'makers-reserve'
                        ? 'makersReserveBrown'
                        : 'blue'
                }
                headlineColor={globalTheme === 'makers-reserve' ? null : 'blue'}
            />
            <ul className={styles.productList}>
                {products.map((product, i) => {
                    if (!product.category || !product.slug) {
                        // These are an absolute must
                        return null;
                    }
                    return (
                        <li className={styles.listItem} key={i}>
                            <CardProduct
                                color={product.color}
                                category={product.category}
                                eyebrow={product.eyebrow}
                                image={product.image}
                                displayName={product.displayName}
                                slug={product.slug}
                                theme={product.theme}
                                award={product.award}
                                id={product.sys.id}
                            />
                        </li>
                    );
                })}
                {endCard?.text && (
                    <li
                        key="end-card"
                        className={styles.listItem}
                        style={{
                            backgroundColor: `${
                                endCard?.backgroundColor
                                    ? getColor(endCard.backgroundColor)
                                    : getColor('blue')
                            }`,
                            color: `${
                                endCard?.textColor
                                    ? getColor(endCard.textColor)
                                    : getColor('cream')
                            }`,
                        }}
                    >
                        {isMakersReserve && (
                            <Img
                                className={styles.endCardImage}
                                src={MAKERS_END_CARD_MOBILE}
                                fallbackImageWidth={768}
                                alt={
                                    'Group of Tillamook Makers Reserve products'
                                }
                                priority
                                customSources={[
                                    {
                                        breakpoint: 1280,
                                        src: MAKERS_END_CARD_DESKTOP,
                                        imageWidth: 1920,
                                    },
                                    {
                                        breakpoint: 768,
                                        src: MAKERS_END_CARD_DESKTOP,
                                        imageWidth: 1536,
                                    },
                                    {
                                        src: MAKERS_END_CARD_MOBILE,
                                        imageWidth: 768,
                                    },
                                ]}
                            />
                        )}
                        <div className={styles.endCardContent}>
                            {!endCard.headline && (
                                <div className={styles.iconGroup}>
                                    <div className={styles.iconWrapper}>
                                        <img
                                            alt=""
                                            src={`/images/icons/morning-star.svg`}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className={styles.contentGroup}>
                                <div className={styles.headlineWrapper}>
                                    <Text
                                        as="h3"
                                        baseTheme={
                                            globalTheme === 'makers-reserve'
                                                ? 'makers36'
                                                : 'headingLarge'
                                        }
                                        themes={{
                                            large:
                                                globalTheme === 'makers-reserve'
                                                    ? 'makers60'
                                                    : 'headingXLarge',
                                        }}
                                        className={styles.headline}
                                    >
                                        {endCard.headline}
                                    </Text>
                                </div>
                                <div className={styles.endCardBody}>
                                    <RichText
                                        richText={endCard.text}
                                        overrides={richTextOverrides}
                                        headline={endCard.headline}
                                    />
                                    {endCard?.cta && (
                                        <ButtonCTA
                                            className={styles.ctaButton}
                                            {...endCard.cta}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </li>
                )}
            </ul>
        </div>
    );
};

BlockSimpleProductList.propTypes = {
    __typename: PropTypes.string,
    anchorId: PropTypes.string,
    products: PropTypes.array,
    headline: PropTypes.string,
    eyebrow: PropTypes.string,
    endCard: PropTypes.shape({
        headline: PropTypes.string,
        text: PropTypes.object,
        cta: PropTypes.object,
        backgroundColor: PropTypes.string,
        textColor: PropTypes.string,
    }),
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
};

export default BlockSimpleProductList;
